<div class="main-group">
	<!--			-->
	<!-- Info -->
	<!--			-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="label-item-name">{{ StudentID }} - {{ PersonName }}</label>
		</div>
	</div>

	<!--			    -->
	<!-- OverridePolicy -->
	<!--	 		   -->
	<div class="main-group-item" style="margin-bottom: 0px" [style.display]="EnableOverrideMode == true ? 'flex' : 'none'">
		<div class="main-policy-item-center">
			<label class="label-policy">District Override Policy</label>
		</div>
	</div>
	<div class="main-group-item" style="margin-top: 0px" [style.display]="EnableOverrideMode == true ? 'flex' : 'none'">
		<div class="main-policy-item-center">
			<label class="label-policy-data">{{ DistrictMTAOverridePolicy }}</label>
		</div>
	</div>

	<!-- 			   			 -->
	<!-- OverrideReason Selector -->
	<!-- 		  	   			 -->
	<div class="main-group-item" [style.display]="EnableOverrideMode == true ? 'flex' : 'none'">
		<div class="selector-item">
			<div>
				<label class="label-item-sel">Override Reason</label>
			</div>

			<div style="margin-left: 10px; width: 325px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="OverrideReasonSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedOverrideReason"
					(ngModelChange)="onOverrideReasonChange($event)"
				>
					<option *ngFor="let r of lstOverrideReason" [ngValue]="r">
						{{ r.MTAOverrideReasonDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 			   		  -->
	<!-- PrintReason Selector -->
	<!-- 					  -->
	<div class="main-group-item" [style.display]="EnableReprintMode == true ? 'block' : 'none'">
		<div class="selector-item">
			<div>
				<label class="label-item-sel">Reprint Reason</label>
			</div>

			<div style="margin-left: 10px; width: 325px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="PrintReasonSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedPrintReason"
					(ngModelChange)="onPrintReasonChange($event)"
				>
					<option *ngFor="let r of lstPrintReason" [ngValue]="r">
						{{ r.IDDepotPrintReasonDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAgree()" [disabled]="isBusy == true">Agree</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
